export const TABLE_KEYS = Object.freeze({
  BOUNCES: "BOUNCES",
  BLOCKS: "BLOCKS",
  SPAM: "SPAM",
});
export const NO_DATA = "NO_DATA";

/**
 * The types of email search we can perform.
 * - EXACT: Exact match search for an email address. This will return a single result if it exists.
 * - CONTAINS: Partial match search for an text within email addresses. This will return all results that match the query.
 * Note that '*' can be used as a wildcard in the CONTAINS method.
 * @enum
 */
export const EmailSearchMethods = Object.freeze({
  EXACT: "Exact",
  CONTAINS: "Contains",
});

// This must match the max page size set in the background
// See the tap_tap-tools-email8 repo src/main/java/com/_8x8/email8/service/SendgridService.java
export const MAX_PAGE_SIZE = 500;

export const RADIO_INFO_MESSAGE = {
  [EmailSearchMethods.EXACT]:
    "Search specifically for a complete email address. This will return a single result per suppression list if the address exists in that list. Date/time range is not applicable.",
  [EmailSearchMethods.CONTAINS]:
    "Search for email addresses containing the given text. This will return all results which match the query *within* the selected date/time range. The '*' character can be used as a wildcard.",
};
